import {URL} from '../../util/ambienteActions';
import axios from 'axios';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {BUSCAR_CLIENTES_EMPRESA} from '../types';

export default function buscarClientesPorEmpresa(empresa) {
    const url = `${URL}/cliente/lista-clientes/empresa/${empresa}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_CLIENTES_EMPRESA,
            payload: response
        }),
    );
}